import type { TeamId } from '../../types/game';
import { TEAM_COLORS } from '../../types/game';

interface MiniScoreboardProps {
  scores: Record<TeamId, number>;
}

export const MiniScoreboard = ({ scores }: MiniScoreboardProps) => {
  const teams: TeamId[] = ['A', 'B', 'C'];

  return (
    <div className="card">
      <h3 className="text-xs font-bold text-muted uppercase tracking-wider mb-3">
        Puntajes
      </h3>
      <div className="flex gap-3">
        {teams.map(team => (
          <div 
            key={team}
            className="flex-1 text-center p-3 rounded-xl border-2 border-white shadow-[2px_2px_0_white]"
            style={{ background: 'var(--color-bg-deep)' }}
          >
            <div 
              className="text-2xl font-black"
              style={{ color: TEAM_COLORS[team].bg }}
            >
              {team}
            </div>
            <div className="text-xl font-bold text-slate-100">
              {scores[team]}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
